var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("bootstrap-box", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c("div", { staticClass: "mb-3" }, [
              _c("i", { staticClass: "fas fa-project-diagram" }),
              _vm._v(" "),
              _c("h3", { staticClass: "box-title" }, [
                _vm._v(
                  _vm._s(_vm.resource("JourneyBuilder_JourneyReport_Title"))
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "configuration-controls" },
              [
                _c(
                  "div",
                  { staticClass: "individual-control journey-selector" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.resource("JourneyBuilder_Shared_Journey"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("journey-dropdown", {
                      model: {
                        value: _vm.journeyIdModel,
                        callback: function($$v) {
                          _vm.journeyIdModel = $$v
                        },
                        expression: "journeyIdModel"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.displayNewSankeyConfiguration
                  ? [
                      _c(
                        "div",
                        { staticClass: "individual-control period-selector" },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.resource(
                                  "JourneyBuilder_Sankey_Period_Label"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("period-id-picker", {
                            model: {
                              value: _vm.periodIdModel,
                              callback: function($$v) {
                                _vm.periodIdModel = $$v
                              },
                              expression: "periodIdModel"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "individual-control inflow-period-selector"
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.resource(
                                  "JourneyBuilder_Sankey_InflowPeriod_Label"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("inflow-period-picker", {
                            model: {
                              value: _vm.inflowPeriodIdModel,
                              callback: function($$v) {
                                _vm.inflowPeriodIdModel = $$v
                              },
                              expression: "inflowPeriodIdModel"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "individual-control product-selector" },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.resource(
                                  "JourneyBuilder_Sankey_ProductIds_Label"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("products-selector", {
                            model: {
                              value: _vm.productNamesModel,
                              callback: function($$v) {
                                _vm.productNamesModel = $$v
                              },
                              expression: "productNamesModel"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "individual-control highlight-mode-selector"
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.resource(
                                  "JourneyBuilder_Sankey_HighlightMode_Label"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("highlight-mode-selector", {
                            model: {
                              value: _vm.highlightMode,
                              callback: function($$v) {
                                _vm.highlightMode = $$v
                              },
                              expression: "highlightMode"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "sankey-explanation" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.resource(
                          "JourneyBuilder_Sankey_TouchpointSelection_Explanation"
                        )
                      )
                    )
                  ])
                ])
              ],
              2
            )
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _vm.periodId
                      ? _c("sankey-v2", {
                          attrs: { "highlight-mode": _vm.highlightMode }
                        })
                      : _c("loading-box")
                  ],
                  1
                )
              ])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }